export default __webpack_public_path__ + "media/images/buyer-seller-ipad-7b80fd08e12066f190b6c4ef4db6a3b0.png";